module.exports = __webpack_public_path__ + "img/bommap1.22034b87.png";